import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("image", {
                href: "/images/social/telegram.png"
            }),
            " : ",
            /*#__PURE__*/ _jsx("image", {
                href: "/images/social/telegram.png"
            })
        ]
    }));
};
export default Icon;
